export const formatDuration = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60); // 분 계산
    const remainingSeconds = Math.floor(seconds % 60); // 초 계산
    return `${minutes}분 ${remainingSeconds}초`;
}; 